import { InfoCircleFilled } from '@/assets/icons'
import { Tag } from '@/components/tag/Tag'
import { JurisdictionIcon } from '@/jurisdiction-mappings/components/JurisdictionIcon'
import type { MatterRead } from '@/matter/store/schemas'
import { useMatterJurisdiction } from '@/matter/components/matter-overview/useMatterJurisdiction'

type MatterDetailsJurisdictionProps = {
  matter: MatterRead
  onEdit: () => void
}

export function MatterDetailsJurisdiction({ matter, onEdit }: MatterDetailsJurisdictionProps) {
  const { jurisdictionLabel, jurisdictionKind, showMissingJurisdiction, canEdit, trackCtaClicked } = useMatterJurisdiction(matter)

  if (jurisdictionLabel) {
    // Figma tag/default/tonal: the normal-case pill form of the DS Tag, not the small-caps status chip.
    return (
      <Tag variant="tonal" color="Black" size="xs" textCase="normal" shape="pill" hasLeadingIcon>
        <JurisdictionIcon kind={jurisdictionKind} className="size-3 shrink-0" />
        {jurisdictionLabel}
      </Tag>
    )
  }

  if (showMissingJurisdiction && !canEdit) {
    return <span className="text-sm font-normal leading-5 tracking-[-0.15px] text-brand-neutral-600">No Jurisdiction Provided</span>
  }

  if (showMissingJurisdiction && canEdit) {
    return (
      <button
        type="button"
        className="inline-flex items-center gap-1.5 rounded text-sm font-medium leading-5 tracking-[-0.15px] text-yellow-800 hocus:underline focus:outline-hidden focus-visible:ring-2 focus-visible:ring-yellow-600"
        onClick={() => {
          trackCtaClicked()
          onEdit()
        }}
      >
        <InfoCircleFilled className="size-3.5 shrink-0 text-yellow-600" aria-hidden="true" />
        <span>No Jurisdiction Provided</span>
      </button>
    )
  }

  return null
}
